<template>
  <q-select
    v-bind="vAttrs"
    :loading="options.length === 0"
    :options="options"
    v-on="$listeners"
  />
</template>

<script>
import { mapState } from 'vuex'
import validateProxyMixin from '@/mixins/validateProxyMixin'

export default {
  name: 'SelectUnavailabilityType',
  mixins: [validateProxyMixin],
  inheritAttrs: false,
  computed: {
    ...mapState({
      CONSTS: 'CONSTS'
    }),
    options () {
      return _.sortBy(_.get(this.CONSTS, 'agentUnavailabilityTypes', []), 'name')
    },
    vAttrs () {
      return {
        label: `Type d'indisponibilité`,
        'option-label': 'name',
        'option-value': 'id',
        ...this.$attrs
      }
    }
  }
}
</script>

<style scoped>

</style>
